import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpEvent,
  HttpHeaders,
  HttpRequest,
  HttpResponse,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { RecepcionDTO } from "src/app/models/dto/entregas.dto";

@Injectable({ providedIn: "root" })
export class RecepcionService {
  constructor(private http: HttpClient) {}

  public get(): Observable<RecepcionDTO[]> {
    return this.http.get<RecepcionDTO[]>(
      `${environment.serverUrl}api/settings/recepcion/get`
    );
  }

  public getById(id: string): Observable<any> {
    return this.http.get<any>(
      `${environment.serverUrl}api/settings/recepcion/getById`,
      { params: { id } }
    );
  }

  public add(
    datos: any,
    files: File[],
    firmaChofer: File,
    firmaSupervisor: File,
    licencia: File
  ): Observable<HttpEvent<any>> {
    const formData = new FormData();
    formData.append("IdChofer", String(datos.IdChofer));
    formData.append("IdSupervisor", String(datos.IdSupervisor));
    formData.append("IdUnidad", String(datos.IdUnidad));
    formData.append("Kilometraje", String(datos.Kilometraje));
    formData.append("PolizaBool", String(datos.PolizaBool));
    formData.append("PolizaVigencia", String(datos.PolizaVigencia));
    formData.append("TanqueGas", String(datos.TanqueGas));
    formData.append("Llantas", String(datos.Llantas));
    formData.append("Golpes", String(datos.Golpes));
    formData.append("Tipo", String(datos.Tipo ?? "X"));
    formData.append("IdAsignacion", String(datos.IdAsignacion));
    formData.append(
      "TarjetaCirculacionBool",
      String(datos.TarjetaCirculacionBool)
    );
    formData.append(
      "TarjetaCirculacionVigencia",
      String(datos.TarjetaCirculacionVigencia)
    );

    formData.append(
      "Funcionamientos",
      String(JSON.stringify(datos.Funcionamientos))
    );
    formData.append(
      "Observaciones",
      String(JSON.stringify(datos.Observaciones))
    );

    // files.forEach((file) => {
    //   formData.append(file.name, file, file.name);
    // });

    if (firmaChofer) {
      formData.append("firmachofer", firmaChofer, "firmachofer");
    }
    if (firmaSupervisor) {
      formData.append("firmaSupervisor", firmaSupervisor, "firmaSupervisor");
    }
    if (licencia) {
      formData.append("licencia", licencia, "licencia");
    }

    const uploadReq = new HttpRequest(
      "POST",
      `${environment.serverUrl}api/settings/recepcion/add`,
      formData
    );
    return this.http.request<any>(uploadReq);
  }

  public addPhoto(asm: string, foto: File): Observable<HttpEvent<any>> {
    const formData = new FormData();
    formData.append("asm", String(asm));
    if (foto) {
      formData.append("foto", foto, "foto");
    }

    const uploadReq = new HttpRequest(
      "POST",
      `${environment.serverUrl}api/settings/recepcion/addPhoto`,
      formData
    );
    return this.http.request<any>(uploadReq);
  }
  public getPdf(i: string): Observable<HttpResponse<Blob>> {
    return this.http.get(`${environment.serverUrl}api/settings/recepcion/pdf`, {
      params: { i },
      responseType: "blob",
      observe: "response",
    });
  }
}
